window.$ = window.jQuery    = require('jquery');

const AjaxLoadPage = function()
{
	const _body                 = $('body');
	const _header               = $('#header');    
	const _introLayer           = $("#layerIntroPage");
	const _webdoorMotion 		= $("#webdoor-motion");
	const toolNav 				= $("#tools-float");

	const pageLoader = function() {
		
		// setTimeout(() => {
		// 	_webdoorMotion.addClass('motion-in'); 
		// }, 500);               
		
		
		setTimeout(() => {
			
			_body.removeClass('scroll-off body-content-loading');			               			
			setTimeout(() => {
				_header.addClass('motion-in');
				$("#ico-whats").addClass("motion-in")
			},500)
			
			setTimeout(() => {
				_introLayer.addClass('motion-out'); 
				toolNav.addClass('motion-in');
			}, (_timerSync + 500));
			setTimeout(()=>{
				_introLayer.removeClass('motion-in '); 
				//_introLayer.hide();
			},2000)

		}, _timerSync);

	}

   
	return {
		init : function(status){

			pageLoader(status);			
			// $(document).on('click', 'a[href]:not(.no-load)', (e) => {
			//     e.preventDefault();
			//     // _introLayer.removeClass('motion-out');
			//     // _introLayer.addClass('motion-in');
			//     // setTimeout(()=> {
			//         window.location.href=e.currentTarget.getAttribute('href');
			//     // } ,700)
			// });

		}
	}

}();

module.exports = AjaxLoadPage;